import {
  Alert,
  Modal,
  ModalContent,
  ModalFooter,
  useToaster
} from "@dealer-center/core-components";
import type { UserPermissionGroupsRemoveModalInterface } from "@dealer-center/ddc-pages-user-permissions-manager-interface";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { usePermissionGroupsForUserRemove } from "@dealer-center/ddc-pages-user-permissions-manager-fetch";
import styled from "styled-components";
import { useEffect } from "react";

const StyledModalContent = styled(ModalContent)`
  padding: 0;
`;

interface RemoveUserFromGroupModalProps {
  show: boolean;
  close: () => void;
  values: UserPermissionGroupsRemoveModalInterface;
}
export const RemoveUserFromGroupModal = ({
  close,
  values,
  show
}: RemoveUserFromGroupModalProps) => {
  const { toastError, toastSuccess } = useToaster();
  const { userId, permissionGroup } = values;
  const { mutate, isError, isSuccess, isPending } =
    usePermissionGroupsForUserRemove(userId, permissionGroup);

  useEffect(() => {
    if (isError) {
      toastError("Error removing user from permission group");
      close();
    }
    if (isSuccess) {
      toastSuccess(
        "Success",
        `Removed ${userId} from ${permissionGroup} successfully`
      );
      close();
    }
  }, [
    isError,
    isSuccess,
    close,
    toastError,
    toastSuccess,
    userId,
    permissionGroup
  ]);

  return (
    <Modal
      className="sample-modal-dialog"
      footer={{
        primary: {
          label: "unused"
        },
        footerComponent: (
          <ModalFooter>
            <SaveAndCancel
              analyticsEventName="Remove User from Permission Group"
              isSaving={isPending}
              saveButtonText="Remove"
              onCancel={close}
              onSave={() => {
                mutate({ userId, permissionGroup });
              }}
            />
          </ModalFooter>
        )
      }}
      header={`Remove User from Permission Group`}
      show={show}
      size="large"
      onHide={close}
    >
      <StyledModalContent>
        <Alert role="alert" type="error">
          Remove <strong>{permissionGroup}</strong> from user{" "}
          <strong>{userId}</strong>?
        </Alert>
      </StyledModalContent>
    </Modal>
  );
};
